import React, { useEffect } from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import File from "@peracto/peracto-editor-ui/dist/File";
import Select from "@peracto/peracto-editor-ui/dist/Select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";

const ImageAndTextForm = ({
    onChange,
    state: { items = [], selectedItemIndex },
}) => {
    const DEFAULT_CARD = {
        url: "",
        mobileUrl: "",
        mobileImagePosition: "center",
        imageAndTextHeading: "Heading",
        imageAndTextSubHeading: "Sub Heading",
        headingColour: "text-brand-black",
        imageAndTextButtonText: "Button Text",
        imageAndTextButtonLink: "#",
        imageAndTextButtonColour: "secondary",
    };

    const buttonColourOptions = [
        { label: "Primary", value: "primary" },
        { label: "Secondary", value: "secondary" },
        { label: "Tertiary", value: "tertiary" },
    ];

    const imageAndTextHeadingColourOptions = [
        { label: "Black", value: "text-brand-black" },
        { label: "White", value: "text-brand-white" },
        { label: "Blue", value: "text-brand-primary" },
        { label: "Orange", value: "text-brand-secondary" },
        { label: "Green", value: "text-brand-tertiary" },
        { label: "Pink", value: "text-brand-quaternary" },
        { label: "Yellow", value: "text-brand-quinary" },
    ];

    const mobileImagePositionOptions = [
        { label: "Left", value: "left" },
        { label: "Centre", value: "center" },
        { label: "Right", value: "right" },
    ];

    useEffect(() => {
        return () => {
            onChange({ selectedItemIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {items?.length === 0 && (
                <>
                    <p>Click 'Add Image and Text' to get started</p>
                    <hr />
                </>
            )}
            {selectedItemIndex !== null &&
                items &&
                items[selectedItemIndex] && (
                    <>
                        <File
                            label="Image URL"
                            value={items[selectedItemIndex].url}
                            onChange={(value) => {
                                const itemsClone = [...items];
                                itemsClone[selectedItemIndex].url = value;

                                onChange({ items: itemsClone });
                            }}
                            isInline={false}
                        />

                        <File
                            label="Mobile Image URL"
                            value={items[selectedItemIndex].mobileUrl}
                            onChange={(value) => {
                                const itemsClone = [...items];
                                itemsClone[selectedItemIndex].mobileUrl = value;

                                onChange({ items: itemsClone });
                            }}
                            isInline={false}
                        />

                        <Select
                            label="Mobile Image Position"
                            value={
                                items[selectedItemIndex].mobileImagePosition ||
                                "center"
                            }
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[
                                    selectedItemIndex
                                ].mobileImagePosition = e.value;

                                onChange({ items: itemsClone });
                            }}
                            options={mobileImagePositionOptions}
                        />

                        <TextInput
                            label="Heading"
                            value={items[selectedItemIndex].imageAndTextHeading}
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[
                                    selectedItemIndex
                                ].imageAndTextHeading = e.target.value;

                                onChange({ items: itemsClone });
                            }}
                        />

                        <Select
                            label="Heading Colour"
                            value={items[selectedItemIndex].headingColour}
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[selectedItemIndex].headingColour =
                                    e.value;

                                onChange({ items: itemsClone });
                            }}
                            options={imageAndTextHeadingColourOptions}
                        />

                        <TextInput
                            label="Sub Heading"
                            value={
                                items[selectedItemIndex].imageAndTextSubHeading
                            }
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[
                                    selectedItemIndex
                                ].imageAndTextSubHeading = e.target.value;

                                onChange({ items: itemsClone });
                            }}
                        />

                        <TextInput
                            label="Button Text"
                            value={
                                items[selectedItemIndex].imageAndTextButtonText
                            }
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[
                                    selectedItemIndex
                                ].imageAndTextButtonText = e.target.value;

                                onChange({ items: itemsClone });
                            }}
                        />

                        <TextInput
                            label="Button Link"
                            value={
                                items[selectedItemIndex].imageAndTextButtonLink
                            }
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[
                                    selectedItemIndex
                                ].imageAndTextButtonLink = e.target.value;

                                onChange({ items: itemsClone });
                            }}
                        />

                        <Select
                            label="Button Colour"
                            value={
                                items[selectedItemIndex]
                                    .imageAndTextButtonColour
                            }
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[
                                    selectedItemIndex
                                ].imageAndTextButtonColour = e.value;

                                onChange({ items: itemsClone });
                            }}
                            options={buttonColourOptions}
                        />

                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={(e) => {
                                const itemsClone = [...items];

                                itemsClone.splice(selectedItemIndex, 1);

                                onChange({
                                    items: itemsClone,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                            Remove Image and Text
                        </button>
                    </>
                )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const itemsClone = [...items, DEFAULT_CARD];
                    onChange({
                        items: itemsClone,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Image and Text
            </button>
        </>
    );
};

export default ImageAndTextForm;
